import { ApiClientBase } from "api/ApiClientBase";
import qs from "qs";

class CoachStatisticsApiClient extends ApiClientBase {
    getCoachStatisticsBySchool(schoolId, { pageNumber = 1 }) {
        return this.get(
            `api/v1/coach-statistics/school/${schoolId}?${qs.stringify({ pageNumber })}`,
        ).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CoachStatisticsApiClient();
